import { render, staticRenderFns } from "./uhoh.vue?vue&type=template&id=5e0f7634&scoped=true&"
import script from "./uhoh.vue?vue&type=script&lang=js&"
export * from "./uhoh.vue?vue&type=script&lang=js&"
import style0 from "./uhoh.vue?vue&type=style&index=0&id=5e0f7634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f7634",
  null
  
)

export default component.exports